import ApiRequest from './ApiRequest';

class BrandsApi extends ApiRequest {
  getBrands() {
    return this.get('brands')
      .then(response => response.data)
      .catch(error => console.log(error)); // eslint-disable-line no-console
  }
}

export default BrandsApi;



// WEBPACK FOOTER //
// ./src/api/BrandsApi.js